import ZpcIcon from '@/assets/icon.png'
export default function GetImageData (code) {
  return new Promise((resolve, reject) => {
    import('qrcode').then((QrCode) => {
      QrCode.toCanvas(code, { errorCorrectionLevel: 'H', type: 'image/png', margin: 1.2, width: 189, height: 189 }, function (err, canvas) {
        if (err) {
          reject(err)
        }
        if (canvas.getContext) {
          var imageWidth = parseInt(canvas.getAttribute('width'))
          var logoWidth = 40
          if (imageWidth % 2 === 1) {
            logoWidth = 41
          }
          var leftTop = (imageWidth - logoWidth) / 2
          var ctx = canvas.getContext('2d')
          ctx.fillStyle = '#ffffff'
          ctx.fillRect(leftTop - 4, leftTop - 4, logoWidth + 8, logoWidth + 8)
          var img = new Image(logoWidth, logoWidth)
          img.onload = () => {
            ctx.drawImage(img, leftTop, leftTop, logoWidth, logoWidth)
            var qrData = canvas.toDataURL()
            resolve(qrData)
          }
          img.src = ZpcIcon
        }
      })
    }).catch((err) => {
      reject(err)
    })
  })
}
